/**
 * NxModalDePin -- poner o cambiar el PIN de una ficha de operacion (PATCH .../colaboradores/{id}/pin).
 *
 * Vivia dentro de ColaboradoresView; SUJ-T13 lo comparte con la ficha unica de la persona, que abre el PIN de CADA
 * negocio de la persona y no solo del negocio del selector. Por eso el nombre del negocio llega por parametro: es el que
 * nombra el eco cuando el PIN no quedo (ecoDelPin.js, Ares #18326).
 *
 * Reglas sin DOM en application/personas/pinDeLaFicha.js; el orden PATCH -> eco -> confirmacion lo cuida
 * scripts/check-eco-del-pin.mjs.
 *
 * @module presentation/shared/NxModalDePin
 */

import { esc } from './texto.js';
import { validarPinNuevo, PARA_QUE_SIRVE_EL_PIN } from '../../application/personas/pinDeLaFicha.js';

/**
 * @param {{businessId: string, colaboradorId: string, nombre: string, negocio: string, alGuardar?: Function}} o
 */
export function abrirModalDePin({ businessId, colaboradorId, nombre, negocio, alGuardar }) {
  const existing = document.getElementById('pin-modal');
  if (existing) existing.remove();

  const modal = document.createElement('div');
  modal.id = 'pin-modal';
  modal.className = 'modal-overlay';
  modal.innerHTML = `
    <div class="modal-box" style="max-width:380px">
      <div class="modal-header">
        <span class="modal-title">&#128273; Configurar PIN</span>
        <button class="modal-close" id="pin-modal-close">&#x2715;</button>
      </div>
      <div class="modal-body">
        <p style="margin-bottom:0.75rem">Colaborador: <strong>${esc(nombre)}</strong>${negocio ? ` · ${esc(negocio)}` : ''}</p>
        <p style="font-size:0.875rem;color:var(--color-text-muted,#8b949e);margin-bottom:1rem" data-pin-para-que>
          ${esc(PARA_QUE_SIRVE_EL_PIN)} Debe tener entre 4 y 6 digitos numericos.
        </p>
        <label class="form-label">Nuevo PIN</label>
        <input type="password" id="pin-input" class="form-control" maxlength="6"
          placeholder="4 a 6 digitos" inputmode="numeric" pattern="[0-9]*"
          style="font-size:1.4rem;letter-spacing:0.5rem;text-align:center">
        <label class="form-label" style="margin-top:0.75rem">Confirmar PIN</label>
        <input type="password" id="pin-confirm" class="form-control" maxlength="6"
          placeholder="Repite el PIN" inputmode="numeric" pattern="[0-9]*"
          style="font-size:1.4rem;letter-spacing:0.5rem;text-align:center">
        <p id="pin-modal-error" class="auth-error" style="display:none;margin-top:0.5rem"></p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-ghost" id="pin-modal-cancel">Cancelar</button>
        <button class="btn btn-primary" id="pin-modal-save">Guardar PIN</button>
      </div>
    </div>`;

  document.body.appendChild(modal);

  const $input = document.getElementById('pin-input');
  const $confirm = document.getElementById('pin-confirm');
  const $error = document.getElementById('pin-modal-error');
  const $save = document.getElementById('pin-modal-save');

  const close = () => modal.remove();
  document.getElementById('pin-modal-close').onclick = close;
  document.getElementById('pin-modal-cancel').onclick = close;

  // Solo aceptar digitos
  [$input, $confirm].forEach(el => {
    el.addEventListener('input', () => { el.value = el.value.replace(/\D/g, ''); });
  });

  $save.onclick = async () => {
    $error.style.display = 'none';
    const v = validarPinNuevo($input.value, $confirm.value);
    if (!v.ok) {
      $error.textContent = v.error;
      $error.style.display = '';
      if (v.error === 'Los PINs no coinciden') $confirm.focus();
      return;
    }
    const pin = v.pin;

    $save.disabled = true;
    $save.textContent = 'Guardando...';

    try {
      const { AsistenciaApiClient } = await import('../../infrastructure/api/AsistenciaApiClient.js');
      await AsistenciaApiClient.setPin(businessId, colaboradorId, pin);
      // Un 2xx no prueba que se guardo (#18326: 204 sin escribir con la ficha en otro negocio). Se confirma con el eco.
      const { ecoDelPin, mensajeDelEco } = await import('../../application/colaboradores/ecoDelPin.js');
      let eco = 'sin_lectura';
      try { eco = ecoDelPin(await AsistenciaApiClient.kiosk(businessId), colaboradorId); } catch { /* sin lectura: se dice */ }
      if (eco !== 'ok') {
        $save.disabled = false;
        $save.textContent = 'Guardar PIN';
        $error.textContent = mensajeDelEco(eco, negocio);
        $error.style.display = '';
        return;
      }
      modal.querySelector('.modal-body').innerHTML = `
        <p style="text-align:center;padding:1rem;font-size:1rem">
          &#10003; PIN configurado para <strong>${esc(nombre)}</strong>.<br>
          <span style="font-size:0.875rem;color:var(--color-text-muted,#8b949e)">
            Ya puede usarlo en el kiosko, el Desktop 1.5 y el Arcade.
          </span>
        </p>`;
      modal.querySelector('.modal-footer').innerHTML =
        '<button class="btn btn-primary" id="pin-ok-btn">Listo</button>';
      document.getElementById('pin-ok-btn').onclick = close;
      if (alGuardar) alGuardar();
    } catch (err) {
      $save.disabled = false;
      $save.textContent = 'Guardar PIN';
      $error.textContent = 'Error al guardar el PIN. Intenta de nuevo.';
      $error.style.display = '';
    }
  };

  $input.focus();
}
